import { useCallback, useEffect } from 'react';
import * as React from 'react';

import { UnicornApi } from '@cld/unicorn-api';

type HeapConfiguratorProps = React.PropsWithChildren<{ unicornApi: UnicornApi }>;

export const HeapConfigurator = ({ children, unicornApi }: HeapConfiguratorProps) => {
  const debugLog = useCallback(
    (...args: Parameters<typeof console.debug>) => {
      if (unicornApi.environmentData.name !== 'production') {
        console.debug(...args);
      }
    },
    [unicornApi.environmentData.name]
  );

  useEffect(() => {
    if (!window.heap) {
      debugLog('Heap.io script API not found');
      return;
    }

    const { plan, productEnvironment, user } = unicornApi.data;

    const identifier = user.email;
    const userProperties = {
      email: user.email,
      cloudName: productEnvironment.cloudName,
      pmPlan: plan.name,
      accountCreationDate: productEnvironment.createdAt,
      userCreationDate: user.createdAt,
      userTechnicalRole: user.technicalRole,
      isCloudinary: user.isCloudinaryEmployee,
      role: user.role,
    };

    // Users that don't have an email remain tracked as anonymous (e.g. Heroku sign on)
    if (identifier) {
      window.heap.identify(identifier);
      debugLog('Heap.io user identified', identifier);
    } else {
      debugLog('Heap.io user anonymous (identifier not available)');
    }

    window.heap.addUserProperties(userProperties);

    debugLog('Heap.io user properties added', userProperties);
  }, [debugLog, unicornApi.data.plan, unicornApi.data.productEnvironment, unicornApi.data.user, unicornApi.environmentData.name]);

  return <>{children}</>;
};
